import React from 'react';

const formatMinutes = (minutes) => {
  if (!Number.isFinite(minutes) || minutes <= 0) {
    return '0 min';
  }
  if (minutes < 60) {
    return `${Math.round(minutes)} min`;
  }
  const hours = minutes / 60;
  if (hours < 24) {
    return `${hours.toFixed(1)} h`;
  }
  const days = hours / 24;
  return `${days.toFixed(1)} d`;
};

const KpiCards = ({ stats }) => {
  if (!stats) {
    return (
      <>
        <div className="kpi-card">
          <div className="kpi-value">0</div>
          <div className="kpi-label">Artículos Totales</div>
        </div>
        <div className="kpi-card critical">
          <div className="kpi-value">0</div>
          <div className="kpi-label">A Producir</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-value">0 min</div>
          <div className="kpi-label">Tiempo Total Prep.</div>
        </div>
        <div className="kpi-card">
          <div className="kpi-value">0%</div>
          <div className="kpi-label">Cobertura Stock</div>
        </div>
      </>
    );
  }

  const totalItems = stats.totalItems ?? 0;
  const totalToProduce = stats.totalToProduce ?? 0;
  const totalPrepMinutes = stats.totalPrepMinutes ?? 0;
  const coverage = Number.isFinite(stats.stockCoverage) ? `${stats.stockCoverage}%` : '0%';

  return (
    <>
      <div className="kpi-card">
        <div className="kpi-value" id="kpi-total-items">{totalItems}</div>
        <div className="kpi-label">Artículos Totales</div>
      </div>
      <div className="kpi-card critical">
        <div className="kpi-value" id="kpi-to-produce">{Math.round(totalToProduce)}</div>
        <div className="kpi-label">A Producir</div>
      </div>
      <div className="kpi-card">
        <div className="kpi-value" id="kpi-prep-time">{formatMinutes(totalPrepMinutes)}</div>
        <div className="kpi-label">Tiempo Total Prep.</div>
      </div>
      <div className="kpi-card">
        <div className="kpi-value" id="kpi-coverage">{coverage}</div>
        <div className="kpi-label">Cobertura Stock</div>
      </div>
    </>
  );
};

export default KpiCards;

